import React from "react";
import { View, StyleSheet } from "react-native";
import { Exam, PaperPlaneTilt } from "@phosphor-icons/react";

import CustomText from "../../common/general/CustomText/CustomText";
import { useGradingCenterSubmissions } from "../../../contexts/GradingCenterContext";

const GradingCenterMetrics: React.FC = () => {
  const { dashboardMetrics } = useGradingCenterSubmissions();
  return (
    <View style={styles.container}>
      <View style={styles.metricsGrid}>
        {/* Assignments to Grade */}
        <View style={styles.metricCard}>
          <View style={styles.metricHeader}>
            <CustomText text="Assignments & Assessments to Grade" size="s" weight="medium" style={styles.metricTitle} />
            <View style={[styles.metricIcon, styles.gradesIcon]}>
              <Exam size={20} color="#FFFFFF" />
            </View>
          </View>
          <CustomText
            text={dashboardMetrics.assignmentsToGrade.toString()}
            size="m"
            textType="display"
            weight="ultraBold"
            style={styles.metricValue}
            useTranslationText={false}
          />
          {/* removing date based stats until better implementation */}
          {/* <CustomText
            text="since_yesterday"
            interpolation={{
              value: "+3",
            }}
            size="s"
            style={styles.metricChange}
          /> */}
        </View>

        {/* Retake Requests */}
        {/* removing date based stats until better implementation */}
        {/* removing retake requests until available from query */}
        {/* <View style={styles.metricCard}>
          <View style={styles.metricHeader}>
            <CustomText text="Retake Requests Pending" size="s" style={styles.metricTitle} />
            <View style={[styles.metricIcon, styles.assignmentsIcon]}>
              <ArrowClockwise size={20} color="#FFFFFF" />
            </View>
          </View>
          <CustomText
            text={metrics.retakeRequests.toString()}
            size="m"
            textType="display"
            weight="ultraBold"
            style={styles.metricValue}
            useTranslationText={false}
          />
          <CustomText
            text="from_last_week"
            interpolation={{
              value: "-1",
            }}
            size="s"
            style={styles.metricChange}
          />
        </View> */}

        {/* New Submissions */}
        <View style={styles.metricCard}>
          <View style={styles.metricHeader}>
            <CustomText text="New Submissions Today" size="s" weight="medium" style={styles.metricTitle} />
            <View style={[styles.metricIcon, styles.studentsIcon]}>
              <PaperPlaneTilt size={20} color="#FFFFFF" />
            </View>
          </View>
          <CustomText
            text={dashboardMetrics.newSubmissionsToday.toString()}
            size="m"
            textType="display"
            weight="ultraBold"
            style={styles.metricValue}
            useTranslationText={false}
          />
          {/* removing date based stats until better implementation */}
          {/* <CustomText
            text="from_yesterday"
            interpolation={{
              value: "+5",
            }}
            size="s"
            style={styles.metricChange}
          /> */}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 32,
  },
  metricsGrid: {
    flexDirection: "row",
    gap: 24,
  },
  metricCard: {
    flex: 1,
    backgroundColor: "#FCFCFD",
    borderRadius: 16,
    padding: 24,
    borderWidth: 1,
    borderColor: "#EAECF0",
  },
  metricHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  metricTitle: {
    color: "#6B7280",
    flex: 1,
    marginRight: 12,
    textTransform: "uppercase",
  },
  metricIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  gradesIcon: {
    backgroundColor: "#22C55E",
  },
  // assignmentsIcon: {
  //   backgroundColor: "#F97316",
  // },
  studentsIcon: {
    backgroundColor: "#913DAF",
  },
  metricValue: {
    color: "#111827",
    marginBottom: 4,
  },
  // metricChange: {
  //   color: "#10b981",
  // },
});

export default GradingCenterMetrics;
